import { Can } from 'providers/casl'
import { onAbTestsAccess, onAbTestsCreateUpdateDelete } from '../features/abTests'
import {
  onAdUnitAccess,
  onAdUnitCreateUpdateDelete,
  onAdUnitMediaTypesCUD,
} from '../features/adUnit'
import {
  onDomainAccess,
  onDomainAdvancedSettingsUpdate,
  onDomainBulkManagementCreate,
  onDomainCreateUpdateDelete,
  onDomainCustomCodeUpdate,
  onDomainRichPlacementsMultiAnchorAccess,
} from '../features/domain'
import { onFinanceAccess } from '../features/finance'
import {
  onGlobalSetupAmazonAccess,
  onGlobalSetupAmazonUpdate,
} from '../features/globalSetup/amazon'
import {
  onGlobalSetupAccess,
  onGlobalSetupWorkspaceUpdate,
  onGlobalSetupWorkspaceUserACUD,
} from '../features/globalSetup/common'
import {
  onGlobalSetupDefaultsPrebidStackAccess,
  onGlobalSetupDefaultsPrebidStackUpdate,
  onGlobalSetupDefaultsRichPlacementsAccess,
  onGlobalSetupDefaultsRichPlacementsUpdate,
} from '../features/globalSetup/defaults'
import {
  onGlobalSetupGoogleAdManagerConnectionAccess,
  onGlobalSetupGoogleAdManagerConnectionUpdate,
} from '../features/globalSetup/googleAccountManagerConnection'
import {
  onGlobalSetupBiddersBidParamsCommonUpdate,
  onGlobalSetupBiddersBidParamsOwnUpdate,
  onGlobalSetupBiddersBidParamsThirdPartyProviderUpdate,
  onGlobalSetupBiddersCUD,
  onGlobalSetupBiddersGeneralBidderConfigOwnUpdate,
  onGlobalSetupBiddersGeneralBidderConfigRead,
  onGlobalSetupBiddersGeneralBidderConfigThirdPartyProviderUpdate,
  onGlobalSetupBiddersOwnUpdate,
  onGlobalSetupBiddersThirdPartyUpdate,
  onGlobalSetupBiddersYieldbirdUpdate,
  onGlobalSetupPrebidBiddersAccess,
  onGlobalSetupPrebidBiddersAddaccess,
  onGlobalSetupPrebidModuleAccess,
  onGlobalSetupPrebidModuleCUD,
  onGlobalSetupPrebidModulesGeneralParamsOwnUpdate,
  onGlobalSetupPrebidModulesInventoryConnectionParamsOwnRead,
  onGlobalSetupPrebidModulesInventoryConnectionParamsOwnUpdate,
  onGlobalSetupPrebidProtectionAccess,
  onGlobalSetupProtectionACUD,
} from '../features/globalSetup/prebid'
import {
  onGlobalSetupSupplyChainAccess,
  onGlobalSetupSupplyChainAddAccess,
  onGlobalSetupSupplyChainCUD,
} from '../features/globalSetup/supplyChain'
import { onViewportCUD } from '../features/globalSetup/viewport'
import { onHistoryAccess } from '../features/history'
import {
  onGamAccountSidebarItemAccess,
  onHelpMenuItemAccess,
  onLayoutAccess,
} from '../features/layout'
import { onPageAccess, onPageAddAccess, onPageCreateUpdateDelete } from '../features/page'
import {
  onPerformanceAllProductAccess,
  onPerformanceGeneralAccess,
  onPerformanceYieldbirdDemandAccess,
} from '../features/performance'
import { onProductAccess, onProductUpdate } from '../features/product'
import { onTagAccess } from '../features/tag'

export const onOwner = (can: Can) => {
  onAbTestsAccess(can)
  onAbTestsCreateUpdateDelete(can)
  onAdUnitAccess(can)
  onAdUnitCreateUpdateDelete(can)
  onAdUnitMediaTypesCUD(can)
  onDomainAccess(can)
  onDomainAdvancedSettingsUpdate(can)
  onDomainBulkManagementCreate(can)
  onDomainCreateUpdateDelete(can)
  onDomainCustomCodeUpdate(can)
  onDomainRichPlacementsMultiAnchorAccess(can)
  onFinanceAccess(can)
  onGamAccountSidebarItemAccess(can)
  onGlobalSetupAccess(can)
  onGlobalSetupAmazonAccess(can)
  onGlobalSetupAmazonUpdate(can)
  onGlobalSetupBiddersBidParamsCommonUpdate(can)
  onGlobalSetupBiddersBidParamsOwnUpdate(can)
  onGlobalSetupBiddersBidParamsThirdPartyProviderUpdate(can)
  onGlobalSetupBiddersCUD(can)
  onGlobalSetupBiddersGeneralBidderConfigOwnUpdate(can)
  onGlobalSetupBiddersGeneralBidderConfigRead(can)
  onGlobalSetupBiddersGeneralBidderConfigThirdPartyProviderUpdate(can)
  onGlobalSetupBiddersOwnUpdate(can)
  onGlobalSetupBiddersThirdPartyUpdate(can)
  onGlobalSetupBiddersYieldbirdUpdate(can)
  onGlobalSetupDefaultsPrebidStackAccess(can)
  onGlobalSetupDefaultsPrebidStackUpdate(can)
  onGlobalSetupDefaultsRichPlacementsAccess(can)
  onGlobalSetupDefaultsRichPlacementsUpdate(can)
  onGlobalSetupGoogleAdManagerConnectionAccess(can)
  onGlobalSetupGoogleAdManagerConnectionUpdate(can)
  onGlobalSetupPrebidBiddersAccess(can)
  onGlobalSetupPrebidBiddersAddaccess(can)
  onGlobalSetupPrebidModuleAccess(can)
  onGlobalSetupPrebidModuleCUD(can)
  onGlobalSetupPrebidModulesGeneralParamsOwnUpdate(can)
  onGlobalSetupPrebidModulesInventoryConnectionParamsOwnRead(can)
  onGlobalSetupPrebidModulesInventoryConnectionParamsOwnUpdate(can)
  onGlobalSetupPrebidProtectionAccess(can)
  onGlobalSetupProtectionACUD(can)
  onGlobalSetupSupplyChainAccess(can)
  onGlobalSetupSupplyChainAddAccess(can)
  onGlobalSetupSupplyChainCUD(can)
  onGlobalSetupWorkspaceUpdate(can)
  onGlobalSetupWorkspaceUserACUD(can)
  onHelpMenuItemAccess(can)
  onHistoryAccess(can)
  onLayoutAccess(can)
  onPageAccess(can)
  onPageAddAccess(can)
  onPageCreateUpdateDelete(can)
  onPerformanceAllProductAccess(can)
  onPerformanceGeneralAccess(can)
  onPerformanceYieldbirdDemandAccess(can)
  onProductAccess(can)
  onProductUpdate(can)
  onTagAccess(can)
  onViewportCUD(can)
}
